import { Grid, GridItem } from '@sequencehq/core-components'
import { ResolvedIntegration } from 'modules/Integrations/domain'
import { IntegrationDetailHeader } from './IntegrationDetailHeader'

type IntegrationDetailProps = {
  integration: ResolvedIntegration
}

export const IntegrationDetail = (props: IntegrationDetailProps) => {
  const ContentComponent = props.integration.components.detail

  return (
    <Grid
      gridTemplateRows={'auto 1fr'}
      data-testid={`integrationsBrowser.detail.${props.integration.id}`}
    >
      <GridItem>
        <IntegrationDetailHeader integration={props.integration} />
      </GridItem>
      <GridItem padding="20px">
        <ContentComponent />
      </GridItem>
    </Grid>
  )
}
